<h1 mat-dialog-title class="dialog-title">{{ 'idleCountdownDialog.sessionExpiration' | transloco }}</h1>
<div mat-dialog-content class="dialog-content">
    <p>{{ 'idleCountdownDialog.loggedOutIn' | transloco: { countdown: data.countdown } }}</p>
</div>